const ANTENNE_RATEAU = 'ANTENNE_RATEAU';
const ANTENNE_INTERIEURE = 'ANTENNE_INTERIEURE';
const ADSL_FIBRE = 'ADSL_FIBRE';
const PARABOLE = 'PARABOLE';
const CABLE = 'CABLE';
const AUTRE = 'AUTRE';
const DEFAUT_RECEPTION = 'DEFAUT_RECEPTION';
const DEMANDE_AIDE = 'DEMANDE_AIDE';
const PARTICULIER = 'PART';
const PROFESSIONNEL_RECEPTION = 'PRO';
const SYNDIC_BAILLEUR = 'GEST_SYNDIC';
const ELU = 'ELU';
const JOURNALISTE = 'PRO_JOURNALISTE';

const MODE_RECEPTION = {
  ANTENNE_RATEAU: ANTENNE_RATEAU,
  ANTENNE_INTERIEURE: ANTENNE_INTERIEURE,
  ADSL_FIBRE: ADSL_FIBRE,
  PARABOLE: PARABOLE,
  CABLE: CABLE,
  AUTRE: AUTRE,

  VALUES: [
    ANTENNE_RATEAU,
    ANTENNE_INTERIEURE,
    ADSL_FIBRE,
    PARABOLE,
    CABLE,
    AUTRE
  ]
};

const RAISON_DEMANDE = {
  DEFAUT_RECEPTION: DEFAUT_RECEPTION,
  DEMANDE_AIDE: DEMANDE_AIDE,

  VALUES: [
    DEFAUT_RECEPTION,
    DEMANDE_AIDE
  ]
};

const TYPE_PERSONNE = {
  PARTICULIER: PARTICULIER,
  PROFESSIONNEL_RECEPTION: PROFESSIONNEL_RECEPTION,
  SYNDIC_BAILLEUR: SYNDIC_BAILLEUR,
  ELU: ELU,
  JOURNALISTE: JOURNALISTE,
  AUTRE: AUTRE,

  VALUES: [
    PARTICULIER,
    PROFESSIONNEL_RECEPTION,
    SYNDIC_BAILLEUR,
    ELU,
    JOURNALISTE,
    AUTRE
  ]
};

export { MODE_RECEPTION, TYPE_PERSONNE, RAISON_DEMANDE };



// WEBPACK FOOTER //
// ./src/modules/accueil/model.js